import { render, staticRenderFns } from "./entity-details.vue?vue&type=template&id=3a77e3c0&scoped=true"
import script from "./entity-details.vue?vue&type=script&lang=js"
export * from "./entity-details.vue?vue&type=script&lang=js"
import style0 from "./entity-details.vue?vue&type=style&index=0&id=3a77e3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77e3c0",
  null
  
)

export default component.exports